export const lojaFilterFields = [
  { name: "nome", label: "Nome", placeholder: "Buscar por nome..." },
  {
    name: "endereco",
    label: "Endereço",
    placeholder: "Buscar por endereço...",
  },
  {
    name: "cnpj",
    label: "CNPJ",
    placeholder: "Buscar por CNPJ...",
  },
  {
    name: "telefone",
    label: "Telefone",
    placeholder: "Buscar por telefone...",
  },
];
